import { validateIntegerNumbers } from "constants/regExp";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import styles from "./NumberInput.module.scss";

type Props = {
  value?: string | number;
  error?: boolean;
  prefix?: string;
  suffix?: string;
  thousandSeparator?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  InputStyle?: React.CSSProperties;
  decimalScale?: number;
  maxLength?: number;
  name?: string;
  placeholder?: string;
  validateValue?: RegExp | null;
  valueIsNumericString?: boolean;
  allowLeadingZeros?: boolean;
};

export const NumberInput = ({
  value,
  error,
  prefix,
  onChange,
  suffix,
  thousandSeparator = ",",
  InputStyle,
  disabled,
  decimalScale,
  maxLength,
  name,
  placeholder,
  validateValue,
  valueIsNumericString,
  allowLeadingZeros,
}: Props) => {
  const [inputValue, setInputValue] = useState<string | null>("");
  const [formattedValue, setFormattedValue] = useState<string | null>("");

  useEffect(() => {
    const numericStringValue =
      typeof value === "string"
        ? `${value.replace(",", "")}`
        : value === null
        ? ""
        : `${value}`;
    const numberValue = value === "" ? value : `${Number(value)}`;
    const valueFormat =
      validateIntegerNumbers.test(String(value)) && !allowLeadingZeros
        ? numberValue
        : numericStringValue;
    if (value !== inputValue) {
      setInputValue(valueFormat);
      setFormattedValue(valueFormat);
    }
  }, [value]);

  return (
    <NumericFormat
      value={formattedValue}
      prefix={prefix}
      onBlur={() => {
        inputValue !== null && onChange(inputValue);
      }}
      onValueChange={(values) => {
        setInputValue(values.value);
        setFormattedValue(values.formattedValue);
      }}
      name={name}
      suffix={suffix}
      disabled={disabled}
      maxLength={maxLength}
      placeholder={placeholder}
      valueIsNumericString={valueIsNumericString}
      allowLeadingZeros={allowLeadingZeros}
      className={styles.inputWrapper}
      style={{
        width: "100%",
        borderRadius: "6px",
        border: error ? "1px solid #DE3535" : "1px solid #D3D3D3",
        padding: "14px 10px",
        height: "44px",
        fontFamily: "'Open Sans', sans-serif",
        fontSize: "14px",
        outline: "none",
        color: disabled && !error ? "#BFBFBF" : error ? "#DE3535" : "#3D3D3D",
        ...InputStyle,
      }}
      decimalScale={decimalScale}
      thousandSeparator={thousandSeparator}
      isAllowed={(values) => {
        return validateValue ? validateValue.test(values.value) : true;
      }}
    />
  );
};
